export const setGtag = (): void => {
	function gtag() {
		// Sonar arguments spread is not possible since prototype is deleted
		window.dataLayer.push(arguments) //NOSONAR
	}
	window.gtag = gtag
}
